/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  var map;
  var infowindow;
  var bounds;
  var markers = [];
  var markersPOI = [];
  var markersDIN = [];
  var markersAPT = [];
  var loadCallback;
  // Define Northstar app
  Northstar.maps = {


     loadMapAPI: function (callback) {
          //console.log('Northstar maps.js loaded');
          loadCallback=callback

      if ($('.google-map').length) {
        var js_file = document.createElement('script');
        js_file.type = 'text/javascript';
        js_file.defer = true;
        
        // Update the key value with NTG API Key
        js_file.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyAYK158TSlUCKaHmThzkflDMSJZUGpw1b8&callback=Northstar.maps.initMaps';
        document.getElementsByTagName('head')[0].appendChild(js_file);
      }
    },

    // Clear markers
     clearMarkers: function (typ) {

         var markset =null;
         if (typ == "DIN") { markset = markersDIN;}
         else if (typ == "POI") { markset = markersPOI;}
         else if (typ == "APT") { markset = markersAPT; }
         else { markset = markers; }

    
         for (var i = 0; i < markset.length; i++) {
             markset[i].setMap(null);
         }

         if (typ == "DIN") { markersDIN = []; }
         else if (typ == "POI") { markersPOI = []; }
         else if (typ == "APT") {  markersAPT = []; }
         else { markers=[]; }


    },

    // Add markers to map
    addMarkers: function (markersJSON,bReset) {

        
        if (bReset) {
            Northstar.maps.clearMarkers('');
            bounds = new google.maps.LatLngBounds();
        }
       
        var markset = jQuery.parseJSON(markersJSON);
        if (markset.markers.length == 0) { return; }
        $.each(markset.markers, function (index, venue) {
         
              var icon = {
                  anchor: new google.maps.Point(15,48),
                  scaledSize: new google.maps.Size(30,48)
              }

            icon.url = "/dist/images/icons/markers/venues_hotels.svg" //default

              // Infowindow contents and icon SVG
              var infohtml = '';
              //console.log(venue.type)
              switch (venue.type) {
                  case 'sponsor':
                  case 'venues_hotels':
                      infohtml = '<div class="infowindow-card">';
                      infohtml += '<div class="venue-card venue-card-vertical">';
                      if (venue.image && venue.image!="") {
                          infohtml += '<div class="venue-gallery-preview"><img class="img-fluid" src="' + venue.image + '" alt=""/></div>';
                      }
                      if (venue.tierNumber && venue.tierNumber>0){
                          infohtml += '<div class="venue-tier">' + 
                            '<div class="tier-number">' + venue.tierNumber + '</div>' +
                            '<div class="tier-label">' + venue.tierLabel + '</div></div>';
                        }
                      if (venue.award && venue.award!="") {
                          infohtml += '<div class="venue-award">' + venue.award + '</div>';
                      }
                      infohtml += '<h5 class="heading-5"><a href="' + venue.url + '">' + venue.title + '</a></h5></div></div>';
                      if (venue.type == 'sponsor') {
                          icon.url = "/dist/images/icons/markers/sponsor.svg";
                      } else {
                          icon.url = "/dist/images/icons/markers/venues_hotels.svg";
                      }
                      break;
                  case 'see_do':
                      icon.url = "/dist/images/icons/markers/see_do.svg";
                      infohtml = '<div class="infowindow-card">';
                      infohtml += '<strong>' + venue.title + '</strong><br>' + venue.description;
                      infohtml += '</div>';
                      break;
                  case 'dining':
                      icon.url = "/dist/images/icons/markers/dining.svg";
                      infohtml = '<div class="infowindow-card">';
                      infohtml += '<strong>' + venue.title + '</strong><br>' + venue.description;
                      infohtml += '</div>';
                      break;
                  case 'airports':
                      icon.url = "/dist/images/icons/markers/airports.svg";
                      infohtml = '<div class="infowindow-card">';
                      infohtml += '<strong>' + venue.title + '</strong><br>' + venue.description;
                      infohtml += '</div>';
                      break;
              }

              // Create marker and extend map bounds to show all markers
              var marker = new google.maps.Marker({
                  position: new google.maps.LatLng(venue.latitude, venue.longitude),
                  map: map,
                  icon: icon,
                  title: venue.title
              });
              markers.push(marker)
              bounds.extend(marker.getPosition());
         
        // Custom style overrides for Infowindows
        google.maps.event.addListener(infowindow, 'domready', function() {
          var iwOuter = $('.gm-style-iw');
          var iwBackground = iwOuter.prev();
          iwBackground.children(':nth-child(2)').css({'display' : 'none'});
          iwBackground.children(':nth-child(4)').css({'display' : 'none'});
          var iwCloseBtn = iwOuter.next();
          iwCloseBtn.hide();
        });

        // Marker click events
        google.maps.event.addListener(marker, 'click', function(e) {
          infowindow.setContent(infohtml);
          infowindow.open(map, this);
          map.panTo(marker.getPosition());
          // Zoom to level 12 if current zoom is less
          if (map.getZoom() < 12) {
            map.setZoom(12);
          }
        });
        });

        if (bReset && markers.length>1) { map.fitBounds(bounds); }
     // callback();
    },


    expandMap: function () {      
      //google.maps.event.trigger(map, 'resize');
    },
    collapseMap: function () {
      //google.maps.event.trigger(map, 'resize');
    },


    // Initialize map
    initMaps: function () {
      infowindow = new google.maps.InfoWindow();
      bounds = new google.maps.LatLngBounds();
      map = new google.maps.Map(document.getElementById('gmap'), {
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        clickableIcons: false
      });


      //styles: mapStyle, clickableIcons: false, draggable: true, fullscreenControl: false, zoomControl: true });
      //Northstar.maps.getMarkersData(function(){
      //  Northstar.maps.addMarkers(function(){
      //    map.fitBounds(bounds);
      //  });
      //});
      // Zooms out 1 level on >768px screens to prevent markers from being too close to map edges
      google.maps.event.addListenerOnce(map, 'idle', function(event) {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.setZoom(map.getZoom()-1);
        }
      });
      google.maps.event.addListener(map, 'click', function(event) {
        infowindow.close();
      });


      loadCallback(map);
    }



  };


}(jQuery, this, this.document));
